<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationTriangle,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faExclamationTriangle,
);
export default {
};
</script>

<template lang="html">
  <div class="page-not-found is-flex">
    <font-awesome-icon :icon="['fal', 'exclamation-triangle']" size="4x"/>
    <div class="page-message is-size-5">
      <p>Sorry, you are not authorized to access this content.</p>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  .page-not-found
    height: 100vh
    align-items: center
    justify-content: center
    flex-direction: column
  .page-message
    margin-top: 1rem
</style>
